export default __webpack_public_path__ + "static/version-switcher-04c9bc046908f3e5b81757f1a1302f30.png";